export default {
    categories: [
        {
            icon: "home",
            key: "home",
            route: "home",
            title: "Ana Sayfa",
        },
        {
            icon: "settings",
            key: "system-management",
            title: "Sistem Yönetimi",
        },
        {
            icon: "flag",
            key: "reports",
            title: "Raporlar",
        },
        {
            icon: "production_quantity_limits",
            route: "campaign-product-sun",
            key: "campaign-product-sun",
            title: "Güneş Kampanya Ürünleri",
        },
        {
            icon: "groups",
            route: "customer-account",
            key: "customer-account",
            title: "Cariler",
        },
        {
            icon: "payment",
            key: "quick",
            title: "Hızlı Tahsilat",
        },
        {
            icon: "payments",
            key: "payments",
            route: "payments",
            title: "Ödemeler",
        },
        {
            icon: "warning_amber",
            key: "payment-errors",
            route: "payment-errors",
            title: "Hatalı Ödeme İşlemleri",
        },
        {
            icon: "storefront",
            key: "b2b-orders",
            route: "b2b-orders",
            title: "Sipariş Yönetim Merkezi",
        },
        {
            icon: "warehouse",
            key: "warehouse-management",
            title: "Depo Yönetimi",
        },
        {
            icon: "running_with_errors",
            key: "last-week-actions",
            route: "last-week-actions",
            title: "Haftalık İşlem Hareketleri",
        },

        {
            icon: "king_bed",
            key: "user-excuse",
            route: "user-excuse",
            title: "İzin İşlemleri",
        },
        {
            icon: "upcoming",
            key: "notify",
            route: "notify",
            title: "Mail Gönderim Durumu",
        },
        {
            icon: "upcoming",
            key: "notify-sms",
            route: "notify-sms",
            title: "SMS Gönderim Durumu",
        },
    ],
    items: [
        {
            category: "reports",
            icon: "query_stats",
            // key:"daily-total-amount-stats",
            route: "daily-total-amount-stats",
            title: "Plasiyer Tahsilat Raporu",
        },
        {
            category: "reports",
            icon: "flag_circle",
            // key:"vade-tarihi-x-gun-gecmis-faturalar",
            route: "vade-tarihi-x-gun-gecmis-faturalar",
            title: "Vade Tarihi X Gün Geçmiş Faturalar",
        },
        {
            category: "reports",
            icon: "flag_circle",
            // key:"vade-tarihi-x-gun-gecmis-faturalar",
            route: "auto-payment-link-report",
            title: "Otomatik Gönderim Linkleri Raporu",
        },
        {
            category: "reports",
            icon: "restore",
            // key:"last-payment-with-installment-and-10-days-passed-invoices",
            route: "installment-last-day-invoices",
            title: "Son Taksit Günü Bugün Olan Ödemeler",
        },
        {
            category: "reports",
            icon: "payment",
            route: "responsible-user-approve-report",
            // key:"responsible-user-approve-report",
            title: "Sorumlu Personel Taksit Onay Raporu",
        },
        {
            category: "reports",
            icon: "pin_invoke",
            route: "without-invoice-report",
            // key:"responsible-user-approve-report",
            title: "Faturasız Ödeme Linki Gönderim Raporu",
        },
        {
            category: "reports",
            icon: "check_circle",
            route: "successful-sales-report",
            title: "Başarılı Tahsilat Raporu",
        },
        {
            category: "reports",
            icon: "stacked_bar_chart",
            route: "receivable-aging-report",
            title: "Alacak Yaşlandırma Raporu",
        },
        {
            category: "reports",
            icon: "inventory_2",
            route: "special-control-stock-report",
            title: "Özel Kontrol Stok Raporu",
        },
        {
            category: "reports",
            icon: "event_upcoming",
            route: "upcoming-due-collections-report",
            title: "Vadesi Yaklaşan Tahsilatlar",
        },
        {
            category: "reports",
            icon: "leaderboard",
            route: "collection-performance-report",
            title: "Plasiyer Tahsilat Performansı",
        },
        {
            category: "system-management",
            icon: "people",
            route: "user",
            title: "Kullanıcılar",
        },
        {
            category: "system-management",
            icon: "settings_accessibility",
            route: "role",
            title: "Rol Yönetimi",
        },
        {
            category: "system-management",
            icon: "account_balance",
            route: "bank-integration",
            title: "Banka Entegrasyonu",
        },
        {
            category: "system-management",
            icon: "mail_lock",
            route: "mail-integration",
            title: "E-Posta Entegrasyonu",
        },
        {
            category: "system-management",
            icon: "textsms",
            route: "sms-integration",
            title: "SMS Entegrasyonu",
        },
        {
            category: "system-management",
            icon: "dns",
            route: "system-parameter",
            title: "Sistem Parametreleri",
        },
        {
            category: "system-management",
            icon: "dns",
            route: "bank-installment",
            title: "Banka Taksit İşlemleri",
        },
        {
            category: "system-management",
            icon: "campaign",
            route: "bank-installment-campaign",
            title: "Banka Taksit Kampanya İşlemleri",
        },
        {
            category: "system-management",
            icon: "contact_page",
            route: "user-report-assign",
            title: "Kullanıcı Rapor Ataması",
        },
        {
            category: "system-management",
            icon: "travel_explore",
            route: "navigation-report",
            title: "Kullanıcı Ekran Hareketleri",
        },
        {
            category: "system-management",
            icon: "beach_access",
            route: "user-excuse-type",
            title: "İzin Türü İşlemleri",
        },
        {
            category: "system-management",
            icon: "inventory_2",
            route: "special-control-stock",
            title: "Özel Kontrol Stokları",
        },
        {
            category: "quick",
            icon: "campaign",
            route: "quick-payment-installment",
            title: "Taksit Yapılabilir Ödemeler",
        },
        {
            category: "warehouse-management",
            icon: "view_cozy",
            route: "warehouse-cell-definition",
            title: "Hücre Tanımlama",
        },
        {
            category: "warehouse-management",
            icon: "inventory_2",
            route: "warehouse-cell-balance",
            title: "Stok Durumu",
        },
        {
            category: "warehouse-management",
            icon: "swap_horiz",
            route: "warehouse-internal-transfer",
            title: "Hücre Transferi",
        },
        {
            category: "warehouse-management",
            icon: "outbox",
            route: "warehouse-shipment-transfer",
            title: "Sevkiyat İşlemleri",
        },
        {
            category: "warehouse-management",
            icon: "archive",
            route: "warehouse-goods-receipt",
            title: "İade / Mal Kabul İşlemleri",
        },

        // {
        //     category:'quick',
        //     icon:'campaign',
        //     route:'quick-payment',
        //     title:'Ödemeler'
        // },
    ],
};
